<template>
  <div>
    正在登录统一门户
  </div>
</template>
<script>
/* eslint-disable */
import * as dd from 'dingtalk-jsapi'

export default {
  data () {
    return {
      titleName: '',
      corpId: '',
    }
  },
  watch: {
    '$route': {
      handler () {
        this.dindin(this.corpId)
      },
      deep: true
    }
  },
  created () {
    console.log(dd.env)
    this.initData()
  },
  mounted () {
    // this.dindin()
  },
  methods: {
    dindin (data, param) {
      if (dd.env.platform !== 'notInDingTalk') {
        dd.ready(function () {
          dd.runtime.permission.requestAuthCode({
            corpId: data,
            onSuccess: function (info) {
              window.location.href = window.location.origin + '/sso/dingDing/autoLoginByCode' + param + '&fromType=mobile&code=' + info.code
            },
            onFail: function (err) {
              alert(err.errorMessage)
            }
          })
        })
      }
    },
    initData () {
      let param = window.location.search ? window.location.search + '&type=dingding' : '?type=dingding'
      this.$request.post('/sso/backgroundSet/findUsedBgSet').then(res => {
        const { code, data } = res.data
        const settingLogin = res.data.extra
        if (code === 'OK') {
          this.corpId = settingLogin.dingding.corpId
          this.dindin(this.corpId, param)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
  }
}
</script>
